module.exports = __webpack_public_path__ + "img/t1-duo-2.bfe8d47d.png";